import { TFunction } from 'i18next';
import { AttachmentType } from '@/entities/consignments';

export const getTypeLabelRecords = (t: TFunction): Record<AttachmentType, string> => ({
  WB: t('onlinesrf.attachment.type.WB.label'),
  PL: t('onlinesrf.attachment.type.PL.label'),
  PC: t('onlinesrf.attachment.type.PC.label'),
  GI: t('newcmr.attachments.type.GI.label'),
  GO: t('newcmr.attachments.type.GO.label'),
  LR: t('newcmr.attachments.type.LR.label'),
  OT: t('onlinesrf.attachment.type.OT.label')
});
